import { FormArray, ValidationErrors, ValidatorFn } from '@angular/forms';

export function atLeastOneValidator(key: string): ValidatorFn {
  return (formArray: FormArray): ValidationErrors | null => {
    const hasOne = formArray.controls.some(group => group.value[key] === true);
    return hasOne ? null : { atLeastOne: true };
  };
}
